export default "__VITE_ASSET__PrKB58Xz__"